import { render, staticRenderFns } from "./note-manage-modal.vue?vue&type=template&id=e0b5bff4&"
import script from "./note-manage-modal.vue?vue&type=script&lang=js&"
export * from "./note-manage-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports